import { formatINR, formatIndianDate } from "./format";

const MODE = { cash: "Cash", upi: "UPI", bank: "Bank Transfer", other: "Other" };
export const modeLabel = (m) => MODE[m] || m;
const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export const receiptRows = (r, names) => [
  ["Receipt no.", r.receipt_number], ["Payment date", formatIndianDate(r.payment_date)], ["Loan ID", r.loan_number],
  ["CLF", names.clf[r.clf_id]], ["VO", names.vo[r.vo_id]], ["SHG", names.shg[r.shg_id]],
  ["Member", r.member_id ? names.member[r.member_id] : "SHG (group loan)"],
  ["Instalment", r.instalment_no ? `#${r.instalment_no} · due ${formatIndianDate(r.emi_due_date)}` : "—"],
  ["EMI amount due", formatINR(r.emi_amount_due)], ["Amount received", formatINR(r.amount)],
  ["Payment mode", modeLabel(r.mode)], ["Reference no.", r.reference || "—"], ["Collected by", r.collected_by],
  ["Outstanding after payment", formatINR(r.outstanding_after)], ["Remarks", r.remarks || "—"],
];

export const printReceipt = (r, names) => {
  const w = window.open("", "_blank", "width=720,height=900");
  if (!w) return false;
  const rows = receiptRows(r, names).map(([k, v]) => `<tr><td>${esc(k)}</td><td>${esc(v)}</td></tr>`).join("");
  const reversed = r.status === "reversed"
    ? `<div class="rev">REVERSED on ${esc(formatIndianDate(r.reversed_at))} by ${esc(r.reversed_by)} — ${esc(r.reversal_reason)}</div>` : "";
  w.document.write(`<!doctype html><html><head><title>${esc(r.receipt_number)}</title><style>
    body{font-family:Arial,sans-serif;color:#0b2a20;padding:32px;max-width:640px;margin:auto}
    h1{font-size:20px;margin:0}.sub{color:#557;font-size:12px;margin-bottom:20px}
    table{width:100%;border-collapse:collapse;font-size:13px}td{padding:7px 4px;border-bottom:1px solid #e5e7eb}
    td:first-child{color:#556;width:45%}td:last-child{font-weight:600;text-align:right}
    .rev{margin:16px 0;padding:10px;border:2px solid #b91c1c;color:#b91c1c;font-weight:700;text-align:center}
    .sig{margin-top:56px;display:flex;justify-content:space-between;font-size:12px;color:#556}
  </style></head><body><h1>EMI SHAKTI — Repayment Receipt</h1>
  <div class="sub">Sarbajaya Cluster Level Federation (CLF) · Printed ${esc(formatIndianDate(new Date()))}</div>${reversed}<table>${rows}</table>
  <div class="sig"><span>Received by: ________________</span><span>Member / SHG signature: ________________</span></div>
  <div class="sub" style="margin-top:28px;text-align:center">EMI SHAKTI · Track Every Loan. Empower Every Woman. · Developed by Business Barao</div>
  <script>window.onload=()=>{window.print()}</script></body></html>`);
  w.document.close();
  return true;
};
